import { Context } from '@/context/appContext';
import { AppStateActions } from '@/reducers/appReducer';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { useContext } from 'react';
import { AuthView } from './AuthView';
import { RestoreView } from './RestoreView';

function AuthModal() {
  const {
    state: { authState },
    dispatch,
  } = useContext(Context);

  const handleClose = () => dispatch({ type: AppStateActions.SET_AUTH_STATE, payload: {} });

  // One responsive dialog at every width. The old mobile path was a `fullScreen` MUI dialog
  // with its own AppBar close button; DialogContent already caps itself at
  // `calc(100% - 2rem)` and DialogContent's own close-X serves both.
  return (
    <Dialog open={!!authState.state} onOpenChange={(open) => !open && handleClose()}>
      <DialogContent className="gap-0 sm:max-w-md">
        {authState.state === 'RESTORE' ? <RestoreView /> : <AuthView />}
      </DialogContent>
    </Dialog>
  );
}

export { AuthModal };
